import script from "./TiptapDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapDisplay.vue?vue&type=script&setup=true&lang=js"

import "./TiptapDisplay.vue?vue&type=style&index=0&id=521ec740&lang=css"

const __exports__ = script;

export default __exports__